import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import languaje from '$constants/languaje';
import { GroupedCountries } from '$constants/countries';
import { files } from '$constants/Files';
import { FilterInput } from './FilterInput';
import classes from './Filters.module.css';
import { FilterSalary } from './FilterSalary';
import { FilterCheckbox } from './FilterCheckbox';
import { useGetFileCategoriesQuery } from '../../../../store/modules/form-info';
import FilterMultiSelectWithGroups from './FilterMultiSelectWithGroups/FilterMultiSelectWithGroups';
import FilterSelect from './FilterSelect/FilterSelect';

export const Filters = () => {
  const [educationLevel, setEducationLevel] = useState<string>('None');
  const [englishLevel, setEnglishLevel] = useState<string>('None');
  const [selectedLanguage, setSelectedLanguage] = useState('None');
  const [t] = useTranslation('global');
  const { data } = useGetFileCategoriesQuery({ t });

  const fileCategories = useMemo(() => {
    return (
      data && [
        { id: files.CURRICULUM, text: files.CURRICULUM },
        { id: files.VIDEO, text: files.VIDEO },
        ...data.map((option) => ({
          id: `${option.CategoryName}`,
          text: option.CategoryName,
        })),
      ]
    );
  }, [data]);

  return (
    <div className={classes.Container} data-testid="filters-section">
      <FilterInput title={t('Filters.skills')} matchInput />
      <FilterInput title={t('Filters.experience')} />
      <FilterMultiSelectWithGroups
        title={t('Filters.country')}
        data={GroupedCountries}
      />
      <FilterSelect
        title={t('Filters.language')}
        placeholder={selectedLanguage}
        setCategory={setSelectedLanguage}
        options={languaje
          .map(({ title }) => ({
            id: title,
            text: title,
          }))
          .sort((a, b) =>
            a.text.toLowerCase().localeCompare(b.text.toLowerCase())
          )}
      />
      <FilterSelect
        title={t('Filters.education')}
        placeholder={educationLevel}
        setCategory={setEducationLevel}
        options={[
          { id: 'PhD', text: t('education.phd') },
          { id: 'Masters Degree', text: t('education.md') },
          { id: 'Bachelors Degree', text: t('education.bd') },
          { id: 'Associate Degree', text: t('education.assocDeg') },
          { id: 'High School', text: t('education.hs') },
        ]}
      />
      <FilterSelect
        title={t('Filters.englishLevel')}
        placeholder={englishLevel}
        setCategory={setEnglishLevel}
        options={[
          { id: 'A1', text: 'A1' },
          { id: 'A2', text: 'A2' },
          { id: 'B1', text: 'B1' },
          { id: 'B2', text: 'B2' },
          { id: 'C1', text: 'C1' },
          { id: 'C2', text: 'C2' },
        ]}
      />
      <FilterSalary />

      <FilterInput title={t('Filters.yearsOfExperience.title')} nameField />
      <FilterCheckbox title={t('Filters.files')} options={fileCategories} />
      <FilterInput title={t('Filters.additionalTags')} matchInput />
      <FilterInput title={t('Filters.name')} nameField />
    </div>
  );
};
